import {Injectable} from '@angular/core';
import {environment} from './../../environments/environment';
import {RequesterService} from './requester.service';

@Injectable({
    providedIn: 'root'
})
export class RequesterServerService extends RequesterService {

    protected getApiUrl(method: string): string {
        return environment.appServerApiUrl + method;
    }
}
